import { NMAWindow } from "./nma-window";
import { isMobileApp } from "./nmaEnvironmentUtils";

declare const window : NMAWindow;

const HYBRID_LIFECYCLE_BRIDGE_HANDLER = 'hybrid_lifecycle_events';

// this event is poorly named, this is just a signal to NMA webview that the page is ready to be shown.
const DEPRECATED_DISPLAY_READY_EVENT_NAME = 'nma_page_fcp';

export enum LifecycleEvent {
    // Indicates that the web content is ready for display and NMA can disable any native overlays
    READY_TO_DISPLAY = "hybrid_ready_to_display"
}

/**
 * Signals to NMA Webview that a particular web lifecycle event has occurred
 * @param event - specific lifecycle event that has occurred
 */
export function notifyNmaOfHybridLifecycleEvent(event: LifecycleEvent): void {
    // safety check to ensure this doesn't blow up if called on node side.
    if (typeof window === "undefined") {
        console.error("[NMA-Utils] readyForNmaDisplay can only run in a browser environment")
        return
    }

    if (!isMobileApp()) return

    // iOS case
    window?.webkit?.messageHandlers[HYBRID_LIFECYCLE_BRIDGE_HANDLER]?.postMessage(event);
    // Android case
    window[HYBRID_LIFECYCLE_BRIDGE_HANDLER]?.postMessage(event);

    // Additionally, invoke deprecated function until minimum supported NMA version supports HYBRID_LIFECYCLE_BRIDGE_HANDLER
    // Removal ticket: MB-923
    if (event == LifecycleEvent.READY_TO_DISPLAY) {
        notifyNMAOfLegacyFCP()
    }
}

// Legacy function that serves for backwards compatibility. To be removed with MB-923
function notifyNMAOfLegacyFCP() {
    // iOS case
    window?.webkit?.messageHandlers[DEPRECATED_DISPLAY_READY_EVENT_NAME]?.postMessage(DEPRECATED_DISPLAY_READY_EVENT_NAME);

    // Android case
    window[DEPRECATED_DISPLAY_READY_EVENT_NAME]?.postMessage(DEPRECATED_DISPLAY_READY_EVENT_NAME);
}